/* eslint-disable */
export default {
  feedbackHeader: 'Enviar comentários',
  back: 'Voltar',
  revert: 'Reverter',
  instruction:
    'Seus comentários são importantes para nós. Se estiver com dificuldades para usar o aplicativo, quiser solicitar um recurso ou comunicar um problema, ficaremos felizes em ajudá-lo.',
  fillForm: 'Preencha o formulário abaixo e clique ',
  useMailBox: ' ou use sua caixa de correio e envie sua solicitação para ',
  email: 'Seu endereço de email',
  reply: '(para que possamos respondê-lo)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Tópico do comentário',
  topicPlaceHolder: 'Selecione uma opção',
  bugReport: 'Relatório de problemas',
  featureRequest: 'Solicitação de recurso',
  others: 'Outros',
  subject: 'Assunto',
  subjectPlaceHolder: 'Diga como podemos ajudá-lo',
  description: 'Descrição completa',
  descriptionPlaceHolder: 'Inclua o máximo de informação possível',
  send: 'Envie seus comentários',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
